<template>
  <div class="loader-container">
      <a-spin size="large"/>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .loader-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        flex-grow: 1;
    }
</style>